import { ModuleElementType } from '@models/enums/module-element-type';

export const CAN_DROP_ACCESS_SECTION: Record<ModuleElementType, ModuleElementType[]> = {
  [ModuleElementType.module]: [ModuleElementType.section],
  [ModuleElementType.section]: [ModuleElementType.step],
  [ModuleElementType.step]: [ModuleElementType.site],
  [ModuleElementType.site]: []
};
